import _classCallCheck from "/opt/ci/workspace/LandingPages_KTMed_MDR_Release/target/checkout/html/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var EmailJSResponseStatus = function EmailJSResponseStatus(httpResponse) {
  _classCallCheck(this, EmailJSResponseStatus);

  this.status = httpResponse.status;
  this.text = httpResponse.responseText;
};